import { ActionType, createAction, createAsyncAction } from 'typesafe-actions'

import { IdIndexedUser } from './types'
import { User } from '../../entities-next/user'

// TODO: Legacy user cache store. Remove

export const fetchUsers = createAsyncAction(
  '/data/user/USERS_FETCH_BEGIN',
  '/data/user/USERS_FETCH_SUCCESS',
  '/data/user/USERS_FETCH_FAILURE'
)<{ currentPage?: number; limit?: number; searchQuery?: string } | undefined, IdIndexedUser, Error>()

export const setOneUser = createAction('/scenes/Dashboard/data/user/SET_ONE_USER', (resolve) => (user: User) =>
  resolve(user)
)

export type UserAction = ActionType<typeof fetchUsers | typeof setOneUser>
